import { render, staticRenderFns } from "./cImport.vue?vue&type=template&id=72feb00b&scoped=true&"
import script from "./cImport.vue?vue&type=script&lang=js&"
export * from "./cImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72feb00b",
  null
  
)

export default component.exports